// The index route renders a home appropriate to the logged-in user's audience (ROLE_AUDIENCE):
// staff/hr get the staff Dashboard, patients get their own-case app, HR gets a placeholder. The
// per-audience THEME is already applied by AppShell via useAudienceTheme; this only picks the home
// content. Clinic users reuse the Dashboard within their (themed, permission-filtered, server-
// scoped) console.
import { ROLE_AUDIENCE } from '@alignova/shared';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.tsx';
import { t } from '../i18n/index.ts';
import { Card, PageHeader } from '../ui/primitives.tsx';
import { PatientHome } from '../pages/PatientHome.tsx';

function HrHome() {
  return (
    <div>
      <PageHeader title={t('hrApp.title')} subtitle={t('hrApp.subtitle')} />
      <Card className="p-6">
        <p className="text-sm text-muted">{t('hrApp.placeholder')}</p>
      </Card>
    </div>
  );
}

export function AudienceHome() {
  const { user } = useAuth();
  const audience = user ? ROLE_AUDIENCE[user.role] : 'staff';
  if (audience === 'clinic') return <Navigate to="/portal" replace />;
  if (audience === 'field') return <Navigate to="/field" replace />;
  if (audience === 'patient') return <PatientHome />;
  if (audience === 'hr') return <HrHome />;
  // Staff home IS the operational (workflow) dashboard — dashboard and workflow are one.
  return <Navigate to="/workflow" replace />;
}
